import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';
import { LoadingScreen } from '@/shared/components/common/LoadingScreen';

const CHANGE_PASSWORD_PATH = '/profile/change-password';

export function ProtectedRoute() {
  const { status, accessToken, user } = useAuthStore();
  const location = useLocation();

  // Still determining auth status — keep showing loading
  // while the 401 interceptor + cookie refresh + React Query
  // retries are completing.
  if (status === 'idle' || status === 'loading') {
    return <LoadingScreen />;
  }

  // Not authenticated — redirect to login with return URL
  if (status !== 'authenticated' || !accessToken) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${returnUrl}`} replace />;
  }

  // Admin issued a temporary password — block every other page until the
  // user sets their own. They already know the temp password (the admin
  // told them out of band), so it doubles as "current password" here.
  if (user?.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return <Outlet />;
}
